// src/components/dashboard/components/StatCard.jsx
import { LucideIcon } from 'lucide-react';

export const StatCard = ({
  title,
  value,
  icon: Icon,
  description,
  className = ''
}) => {
  return (
    <div className={`bg-white dark:bg-slate-800 overflow-hidden shadow rounded-lg ${className}`}>
      <div className="p-5">
        <div className="flex items-center">
          <div className="flex-shrink-0">
            <div className="flex items-center justify-center h-12 w-12 rounded-md bg-blue-100 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400">
              {Icon && <Icon className="h-6 w-6" />}
            </div>
          </div>
          <div className="ml-5 w-0 flex-1">
            <dl>
              <dt className="text-sm font-medium text-gray-500 dark:text-gray-400 truncate">{title}</dt>
              <dd className="flex items-baseline">
                <div className="text-2xl font-semibold text-gray-900 dark:text-white">{value}</div>
              </dd>
              {description && (
                <dd className="mt-1 text-sm text-gray-500 dark:text-gray-400">{description}</dd>
              )}
            </dl>
          </div>
        </div>
      </div>
    </div>
  );
};